<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroDocumentText"></ng-icon>
      <h2>Templates</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Templates</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off" #filterInput>
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Filter by Contract Type</mat-label>
          <input type="text" placeholder="Select Contract Type" matInput [matAutocomplete]="auto" [formControl]="selectedContractType" (input)="onInputChange($event.target.value)" #contractInput>
          <mat-icon matSuffix *ngIf="selectedContractType.value" class="clear-icon"
            (click)="clearField()"><ng-icon name="heroXMark"></ng-icon></mat-icon>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
            <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="inner-box">
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Template Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Template Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ element.templateName | titlecase }} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.description | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Version">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.version }}</mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="Language">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Language</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.language }}</mat-cell>
      </ng-container> -->


      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.updatedDate }}</mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="status-pill" [ngClass]="
          element.status == 1  ? 'success' :
          element.status == 2 ? 'error' :
          'warning'">{{ element.status }}</span>
        </mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple (click)="downloadTemplate(element.templateId)" matTooltip="Download Template {{ element.templateName }}" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <mat-progress-spinner *ngIf="downloadLoading[element.templateId]; else go" mode="indeterminate" color="accent" diameter="24"></mat-progress-spinner>
            <ng-template #go><ng-icon name="faFileWord"></ng-icon></ng-template>
        </a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.data.length > 0 && dataSource.filter && dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no templates found with <strong>'{{dataSource.filter}}'</strong></p>
        <button mat-raised-button color="warn" (click)="clearField()">Reset Filters</button>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && dataSource.data.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p class="text-center">There are no templates found with selected filter! </p>
        <button mat-raised-button color="warn" (click)="clearField()">Reset Filters</button>
      </div>
    </ng-container>

    <ng-container *ngIf="dataLoading">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0 && !dataSource.filter && !dataLoading">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no templates found.</p>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>